/* istanbul ignore file */
// TODO: Покрыть тестами
/** Возвращает новый объект со свойствами, значение которых не undefined */
export const clearUndefinedProps = <T extends Record<string, unknown>>(obj: T) =>
    Object.entries(obj).reduce<Partial<T>>((acc, [key, value]) => {
        if (typeof value !== 'undefined') return { ...acc, [key]: value };

        return acc;
    }, {});
